import { gql } from '@apollo/client'

export const GET_DELIVERIES = gql`
query getDeliveries(
  $limit: Int!
  $offset: Int!
  $status: [String!]!
  $orderNo: String
  $period: PeriodFilter
) {
  merchantDeliveries(
    limit: $limit
    offset: $offset
    status: $status
    orderNo: $orderNo
    period: $period
  ) {
    id
    orderNo
    status
    distance
    deliveryAmount
    customer {
      name
      phone
    }
    rider {
      id
      name
      phone
    }
    pickupPoint {
      placeId
      lat
      lng
      name
    }
    dropoffPoint {
      placeId
      lat
      lng
      name
    }
    note
    createdOn
  }
}
`

export const ASSIGN_RIDER_DELIVERY = gql`
mutation AssignRiderDelivery($riderId: ID!, $orderNo: ID!) {
  assignRiderDelivery(riderId: $riderId, orderNo: $orderNo) {
    rider {
      id
      name
      phone
    }
  }
}
`
